import * as React from 'react';
import { connect } from 'react-redux';
import { interval } from 'rxjs';
import { getIntervalCall, getPromotionalUrl } from '../../../helpers/helpersIndex';
import { exitActionKiosk, kioskIdAndGetTokensDataRequest, setPromotionalDataRequest } from '../../../store/actions';
import PageUnAuthorized from '../../ErrorPages/pages-undisplay';
import ErrorUnTheam from '../../ErrorPages/pages-untheam';
import SessionTimeOut from '../theme1/components/sessionTimeOut';
import Themetwofooter from '../theme1/components/themetwofooter';
import ThemeTwoKioskContainer from '../theme1/container/themetwokioskcontainer';
import { withTranslation } from 'react-i18next';


 

let subscribe;

class KIOSK extends React.Component<any, any> {
    constructor(props) {
        super(props);
        const paramKey = 'kioskid';
        let kioskIdentifier: any = new URLSearchParams(this.props?.location?.search).toString()?.split('=')[0];
        kioskIdentifier = kioskIdentifier.toLowerCase() === paramKey ? new URLSearchParams(this.props?.location?.search).get(kioskIdentifier) : '';
        this.state = {
            kioskIdentifier: kioskIdentifier
        }
        console.log("KioskIndefier==>", {state:this.state.kioskIdentifier,props});
    }
    componentDidMount() {
        if (this.state.kioskIdentifier) {
let path:any = getPromotionalUrl();
            this.props.kioskIdAndGetTokensDataRequest(this.state.kioskIdentifier, true,this.props.t);
            this.props.setPromotionalDataRequest();
            subscribe = interval(60000 * getIntervalCall()).subscribe(() => {
                this.props.kioskIdAndGetTokensDataRequest(this.state.kioskIdentifier, false,this.props.t);
            });
        }
    }
    componentWillUnmount() {
        if (subscribe)
            subscribe.unsubscribe();
    }
    getThemeContainer = (kioskIdentifier, value) => {
        console.log('getThemeContainer=>', kioskIdentifier, value);
        if (kioskIdentifier && kioskIdentifier !== '') {
            return value ? <ThemeTwoKioskContainer /> : <ErrorUnTheam />
        }
        else return <PageUnAuthorized />
    }
    render() {
        const { kioskIdentifier, locationId,t } = this.props;
        console.log('getThemeContainer=11111>', this.props);


        return (
            <>

                <div className='Kiosk_container'>
                    <SessionTimeOut />
                    <main className='Kiosk_maincontent'>
                        {
                            this.state.kioskIdentifier && kioskIdentifier && kioskIdentifier !== 'kid' &&
                            <> {this.getThemeContainer(this.state.kioskIdentifier, locationId)} </>
                        }
                        {(!this.state.kioskIdentifier || (kioskIdentifier && kioskIdentifier === 'kid')) && <PageUnAuthorized />}
                        {/* <PageLoading /> */}
                    </main>
                    <Themetwofooter />
                </div>
                {this.props.loading && <div className="mask_loading"></div>}
            </>
        );
    }
}

const mapStateToProps = state => ({
    kioskIdentifier: state?.kioskReducer2?.kioskIdentifier,
    locationId: state?.kioskReducer2?.locationId,
    dateTime: state?.kioskReducer2?.currentDateAndTime,
    kioskStartTime: state?.kioskReducer2?.kioskStartTime,
    kioskEndTime: state?.kioskReducer2?.kioskEndTime,
    loading : state?.kioskReducer2?.loading
});
export default withTranslation("translations")(connect(mapStateToProps, { kioskIdAndGetTokensDataRequest, exitActionKiosk, setPromotionalDataRequest })(KIOSK)); 
